import Api from '../Api';

import { url } from './config';
import { TravelFileAttribute } from './types';

const api = new Api<TravelFileAttribute>(url);

export default api;
